// List of the GLSL colormaps available,
// to validate against before string replacing.
export const GLSL_COLORMAPS = [
  'plasma',
  'viridis',
  'jet',
];
export const GLSL_COLORMAP_DEFAULT = 'plasma';
export const COLORMAP_SHADER_PLACEHOLDER = 'COLORMAP_FUNC';
